import { useEffect, useState } from "react";
import { getPaymentFees } from "@/lib/api";

// Used until the facility's settings load (or if it has none configured).
export const FALLBACK_PAYMENT_MODES = ["Credit Card", "Debit Card", "UPI", "Payment Link", "Bank Transfer", "Cash"];

let cache = null; // one fetch per page load; Settings edits show up on the next load

/** Active payment modes from Settings → Payment gateway fees, for the active facility.
 *  Any `extra` values (e.g. the mode already saved on a sale being edited) are kept in
 *  the list so old records still display their mode even if it was later removed. */
export function usePaymentModes(...extra) {
  const [modes, setModes] = useState(cache || FALLBACK_PAYMENT_MODES);
  useEffect(() => {
    if (cache) return;
    getPaymentFees()
      .then((r) => {
        const active = (r.items || []).filter((x) => x.active !== false && x.mode).map((x) => x.mode);
        if (active.length) {
          cache = active;
          setModes(active);
        }
      })
      .catch(() => {});
  }, []);
  const missing = extra.filter((v) => v && !modes.includes(v));
  return missing.length ? [...modes, ...new Set(missing)] : modes;
}

/** Call after saving payment modes in Settings so open forms re-fetch. */
export function resetPaymentModesCache() {
  cache = null;
}
